import React from 'react';
import $ from '../../../common/AjaxRequest';
import { Modal, Button, Icon, message, Select } from 'antd';
import SearchSelect from '../../common/SearchSelect';
import API_URL from '../../../common/url';
import '../style.less';
import SearchRetrieve from '../../common/SearchRetrieve.new';
import { map } from 'jquery';

class AddResponseHospital extends React.Component {
    state = {
        visible: false,
        loading: false,
        data: [],
        hospitalOptions: [],
        searchParams: {},
        showList: [],
        AddssuMemberId: "",
        CourtyardAreaList: [],
        needCourtyardArea: false, //院区必填判断
        courtyardAreaName: {},
    };

    show = (record) => {
        this.setState({
            AddssuMemberId: record,
            visible: true,
        });
    };

    hide = () => {
        this.setState({
            visible: false,
            showList: [],
            hospitalOptions: [],
            searchParams: {},
            needCourtyardArea: false,
        });
    };


    hospitalSelectChange = value => {
        const { searchParams } = this.state;
        if (value) {
            searchParams.hospitalMainId = value.value;
            searchParams.hospitalName = value.text;
            searchParams.courtyardArea = undefined;
        } else {
            searchParams.hospitalMainId = '';
            searchParams.hospitalName = '';
        }
        this.setState({ searchParams },() => this.queryCourtyardAreaList());
    }

    queryCourtyardAreaList = () => {
        if (this.timer) {
            clearTimeout(this.timer);
        }
        this.timer = setTimeout(() => {
            const { searchParams: { hospitalMainId } } = this.state;
                if (hospitalMainId !== undefined){
                const options = {
                    method: 'POST',
                    url: API_URL.hospital.queryHospitalCourtyardAreaList,
                    data: {    
                        hospitalMainId,
                    },
                    dataType: 'json',
                    doneResult: res => {
                        const { datas } = res;
                        const {searchParams} = this.state;
                        let { needCourtyardArea } = this.state;
                        needCourtyardArea = false;
                        datas.map(i=>{
                            if (i.courtyardArea) {
                                needCourtyardArea = true;
                            }
                        })
                        searchParams.hospitalId = datas[0].hospitalId;
                        this.setState({ CourtyardAreaList: datas, needCourtyardArea, searchParams });
                    }
                };
                $.sendRequest(options);
        }
        }, 300);
    }

    parseHospitalData = (res, value) => {
        if (res.datas) {
            const sourceData = res.datas;
            const data = sourceData.map(item => ({
                text: `${item.hospitalName}`,
                value: item.hospitalId,
            }));
            this.setState({ hospitalOptions: data });
        } else {
            this.setState({ hospitalOptions: [] });
        }
    }


    // 点击添加负责医院
    AddResponseHospital = () => {
        const { searchParams, showList, AddssuMemberId, CourtyardAreaList, needCourtyardArea } = this.state;
        const { hospitalMainId, hospitalName, courtyardArea, hospitalId } = searchParams;
        if (!hospitalMainId) {
            message.warning(
                '请选择要添加的负责医院',
            );
            return;
        }
        if (hospitalMainId && (!hospitalName)) {
            message.warning(
                '请正确选择所要添加的负责医院',
            );
            return;
        }
        if (needCourtyardArea && !courtyardArea){
            message.warning(
                '请正确选择所要添加的负责院区',
            );
            return;
        }

        const selectItem = hospitalMainId;
        const findVal = showList.findIndex((item) => {
            return item.key == selectItem;
        });
        if (findVal == -1) {

            const options = {
                method: 'POST',
                url: API_URL.hospital.addSsuMemberHospital,
                data: {
                    hospitalId: hospitalId,
                    ssuMemberId: AddssuMemberId,
                },
                dataType: 'json',
                doneResult: data => {
                    if (!data.error) {
                        if(needCourtyardArea && courtyardArea){
                            showList.push(
                                {
                                    value: `${hospitalName}${courtyardArea}`,
                                    key: hospitalId,
                                },
                            );
                        }else{
                            showList.push(
                                {
                                    value: `${hospitalName}`,
                                    key: hospitalId,
                                },
                            );
                        }
                        this.setState({
                            showList,
                        })
                        this.props.loadData();
                    }
                },
                errorResult: () => {
                    return;
                },
            }
            $.sendRequest(options)

        } else {
            message.error(
                '不能添加重复医院'
            );
        }

    }



    getDataList = () => {
        const { showList = [] } = this.state;
        return showList.map(item =>
            (<div className="AddResHospital">
                <div key={item.key}>{item.value}<Icon onClick={() => { this.deleteChooseHospital(item); }}
                    type="close-circle" /></div>
            </div>));
    }

    // 删除选择负责医院
    deleteChooseHospital = (index) => {
        const arr = this.state.showList;
        arr.splice(arr.findIndex(
            item => item.key === index.key), 1);
        this.setState({
            showList: arr,
        });

        this.setState({ loading: true });
        const { AddssuMemberId } = this.state;
        const options = {
            method: 'POST',
            url: `${API_URL.hospital.delSsuMemberHospital}`,
            data: {
                ssuMemberId: AddssuMemberId,
                hospitalId: index.key,
            },
            dataType: 'json',
            doneResult: res => {
                if (!res.error) {
                    message.success(res.success);
                    this.props.loadData();
                }
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);

    }

    courtyardAreaSelectChange = value => {
        const { searchParams } = this.state;
        searchParams.hospitalId = value.value;
        searchParams.courtyardArea = value.text;
        this.setState({ searchParams })
    }

    render() {
        const { visible, loading, searchParams = {} } = this.state;
        const { courtyardArea, hospitalMainId, hospitalName } = searchParams;
        const { hospitalOptions, AddssuMemberId, CourtyardAreaList, needCourtyardArea  } = this.state;
        const AddsearchParam = { ssuMemberId: AddssuMemberId }
        const CourtyardAreaOptions = CourtyardAreaList.map(i => <Option key={i.courtyardArea}>{i.courtyardArea}</Option>)
        return (
            <div>
                <Modal
                    title="添加负责医院"
                    visible={visible}
                    onCancel={this.hide}
                    className="preview-modal inv-detail addHospital"
                    wrapClassName="vertical-center-modal"
                    width="500px"
                    loading={loading}
                    footer={<Button key="back" type="ghost" size="large" onClick={this.hide}>关闭</Button>}
                >
                    <div>
                        <div className="AddResponseHospital">
                            <label className="ui-label">负责医院：</label>

                            {visible &&
                                <SearchRetrieve
                                    keyword="hospitalName"
                                    style={{ width: 250 }}
                                    placeholder="输入医院名称检索"
                                    value={hospitalName}
                                    url={API_URL.hospital.queryHospitalForAdd}
                                    config={{ id: 'hospitalMainId', name: 'hospitalName'}}
                                    onChange={value => this.hospitalSelectChange(value)}
                                />
                            }
                        </div>
                        <div className="AddResponseHospital">
                            <label className="ui-label">负责院区：</label>
                                {/* <Select
                                    onSearch={this.queryCourtyardAreaList}
                                    style={{ width: 250 }}
                                    placeholder="请输入"
                                    disabled={ !needCourtyardArea || !hospitalMainId } //本无院区，禁止填入；本有院区，且医院信息已填，允许填入
                                    value={courtyardArea}
                                    onChange={value => this.courtyardAreaSelectChange(value, 'courtyardArea')}
                                    allowClear={true}
                                >
                                    {CourtyardAreaOptions}
                                </Select>    */}
                                <SearchRetrieve
                                    keyword="courtyardArea"
                                    style={{ width: 250 }}
                                    placeholder="输入院区名称检索"
                                    disabled={ !needCourtyardArea || !hospitalMainId }
                                    value={courtyardArea}
                                    params={{ hospitalMainId }}
                                    url={API_URL.hospital.queryHospitalCourtyardAreaList}
                                    config={{ id: 'hospitalId', name: 'courtyardArea'}}
                                    onChange={value => this.courtyardAreaSelectChange(value)}
                                />
                            
                            <Icon
                                onClick={this.AddResponseHospital}
                                type="plus-circle-o"
                                style={{
                                    fontSize: 20,
                                    width: '20px',
                                    position: 'relative',
                                    color: '#181818',
                                    marginLeft: "10px",
                                    top: '3px',
                                }}
                            />
                        </div>
                        <div className="showHospitalist" style={{ marginLeft: "85px" }} >
                            {this.getDataList()}
                        </div>
                    </div>
                </Modal>
            </div>
        );
    }
}

export default AddResponseHospital;



// WEBPACK FOOTER //
// ./src/components/hospital/ssu/AddResponseHospital.js